import { apiClient } from './api'

export interface ProcedureCategory {
  categoryCode: string
  categoryName: string
  description: string | null
  displayOrder: number
  active: boolean
  createdAt: string
  createdBy: string | null
  updatedAt: string
  updatedBy: string | null
  version: number
}

export interface CreateProcedureCategoryRequest {
  categoryCode: string
  categoryName: string
  description?: string
  active?: boolean
  displayOrder?: number
}

export interface UpdateProcedureCategoryRequest {
  categoryName: string
  description?: string
  active: boolean
  displayOrder: number
  version: number
}

export class ProcedureCategoryService {
  static async getAll(params?: {
    keyword?: string
    active?: boolean
  }): Promise<{ items: ProcedureCategory[]; total: number }> {
    const queryParams = new URLSearchParams()
    if (params?.keyword) queryParams.append('keyword', params.keyword)
    if (params?.active !== undefined) queryParams.append('active', String(params.active))

    const queryString = queryParams.toString()
    const url = queryString ? `/api/categories?${queryString}` : '/api/categories'
    return apiClient.get<{ items: ProcedureCategory[]; total: number }>(url)
  }

  static async getByCode(code: string): Promise<ProcedureCategory> {
    return apiClient.get<ProcedureCategory>(`/api/categories/${code}`)
  }

  static async create(request: CreateProcedureCategoryRequest): Promise<ProcedureCategory> {
    return apiClient.post<ProcedureCategory>('/api/categories', request)
  }

  static async update(code: string, request: UpdateProcedureCategoryRequest): Promise<ProcedureCategory> {
    return apiClient.put<ProcedureCategory>(`/api/categories/${code}`, request)
  }

  static async updateActive(code: string, active: boolean, version: number): Promise<ProcedureCategory> {
    return apiClient.patch<ProcedureCategory>(`/api/categories/${code}/active`, { active, version })
  }

  static async getStats(code: string): Promise<{ procedureTypesCount: number }> {
    return apiClient.get<{ procedureTypesCount: number }>(`/api/categories/${code}/stats`)
  }

  static async delete(code: string): Promise<void> {
    return apiClient.delete(`/api/categories/${code}`)
  }
}
